import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IFareFamily } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { BtnStyleTypes } from 'libraries/ui_button/btn.component';
import { FareFamilyDescriptionDialogComponent, IFareFamilyDialogData } from './fare-family-description-dialog.component';
import { ILanguageCodeValue } from '../../pipes/localized/localized.interface';
import { LocalizedPipe } from '../../pipes/localized/localized.pipe';
import { ISector } from 'libraries/service/resources/model/booking/air/ISector';
import { IFareFamilyDescription, IFareFamilyDictionary } from 'libraries/service/resources/airTrip/IGetAirTripQuotes';
import { FareFamilyService } from './fare-family.service';
import { FareFamilyType } from "@afidium/ts-facade";

@Component({
    selector: 'fare-family',
    template: `
        <div *ngIf="fareFamilyDefinition && fareFamily; else fareFamilyUndefined"
             class="fare-family-container">
            <btn classList="no-spacing wrap-text"
                 cdkOverlayOrigin
                 #trigger="cdkOverlayOrigin"
                 [label]="fareFamilyName"
                 [type]="btnStyleTypes.actionLink"
                 (mouseenter)="showTooltip()"
                 (mouseleave)="hideTooltip()"
                 (click)="showFareFamilyDescription($event)">
            </btn>
            <ng-template
                    cdkConnectedOverlay
                    [cdkConnectedOverlayOrigin]="trigger"
                    [cdkConnectedOverlayOpen]="isTooltipVisible && fareFamilyText?.length > 0">
                <div class="tooltip" [innerHTML]="fareFamilyText"></div>
            </ng-template>
        </div>
        <ng-template #fareFamilyUndefined>
            {{ cabin }}
        </ng-template>
    `,
    styles: [`
        .tooltip {
            padding: .75rem;
            max-width: 30rem;
            background-color: #fff;
            border: 1px solid #bdc3c750;
        }
    `]
})

export class FareFamilyComponent implements OnChanges {

    @Input()
    public fareFamily: IFareFamily;

    @Input()
    public fareFamilyDictionary: { [key: string]: IFareFamilyDictionary };

    @Input()
    public sector: ISector[];

    public fareFamilyName: string;
    public fareFamilyText: string;
    public isTooltipVisible: boolean = false;
    public cabin: string;
    public readonly btnStyleTypes: typeof BtnStyleTypes = BtnStyleTypes;
    public fareFamilyDefinition: IFareFamilyDictionary;

    constructor(
        private readonly matDialog: MatDialog,
        private readonly localizedPipe: LocalizedPipe,
        private readonly fareFamilyService: FareFamilyService,
    ) {
    }

    public ngOnChanges(simpleChanges: SimpleChanges): void {
        if (simpleChanges.fareFamily?.currentValue){
            const fareFamily: IFareFamily = simpleChanges.fareFamily.currentValue;
            this.fareFamilyDefinition = fareFamily.xId && this.fareFamilyDictionary?.hasOwnProperty(fareFamily.xId) ?
                this.fareFamilyDictionary[fareFamily.xId] : null;
            if (this.fareFamilyDefinition) {
                this.fareFamilyName = this.fareFamilyService.getName(this.fareFamilyDefinition.name || {value: this.fareFamilyDefinition.code, languageCode: 'fr'});
                this.fareFamilyText = this.fareFamilyDefinition.description ?
                    this.getDescription(this.fareFamilyDefinition.description) :
                    null;
            }
            this.initCabin();
        }
    }

    public showFareFamilyDescription(event: Event): void {
        event.stopPropagation();
        const data: IFareFamilyDialogData[] = [{
            dictionary: this.fareFamilyDefinition as unknown as FareFamilyType,
            isSelected: true
        }];
        this.matDialog
            .open(FareFamilyDescriptionDialogComponent, {
                minWidth: "800px",
                maxWidth : "90%",
                data
            });
    }

    public showTooltip(): void {
        this.isTooltipVisible = true;
    }

    public hideTooltip(): void {
        this.isTooltipVisible = false;
    }

    private initCabin(): void {
        this.cabin = this.sector?.length ?
            this.sector[0].seat ?
                Object.values(this.sector[0].seat)[0].xCabin :
                "" :
            "";
    }

    private getDescription({languageCode, textLineArray}: IFareFamilyDescription): string {
        const value: string = textLineArray
            .reduce((acc: string, line: string): string => `${acc}<p>${line}</p>`, "");
        const mappedDescription: ILanguageCodeValue[] = [{
            languageCode,
            value
        }];
        return this.localizedPipe.transform(mappedDescription);
    }
}
